var isMultiLevel = function isMultiLevel(opts) {
  return opts.some(function (_ref) {
    var children = _ref.children;
    return children && children.length;
  });
};
export default isMultiLevel;